import * as ActionTypes from './actionTypes';

const initialState = {
  searchResult: [],
  rebateProgram: '',
  used: true,
  unused: true,
  lcb: true,
  opmt: true,
  errors: [],
  selectedPlanType: '',
  isLoading: false,
  planType: [],
  selectedRows: [],
  manufacturerList: [],
  rebateProgramNameValue: '',
  isAllManufacturersSelected: true,
  selectedRowIndex: [],
  exportAllData: [],

  displayObj: {
    used: true,
    unused: true,
    lcb: true,
    opmt: true,
    selectedRows: [],
    searchResult: [],
    rebateProgram: '',
    rebateProgramName: '',
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_PLAN_TYPE_DATA:
      return { ...state, planType: action.payload };

    case ActionTypes.SET_MANUFACTURERS_LIST_UNALLOACTED_BALANCE:
      return { ...state, manufacturerList: action.payload };

    case ActionTypes.GET_UNALLOCATED_BALANCE_REPORT:
      let localState = {};
      if (action.exportAll) {
        localState = { exportAllData: action.payload };
      } else {
        let displayObj = {
          ...state.displayObj,
          searchResult: action.payload,
        };
        localState = { searchResult: action.payload, displayObj };
      }
      return { ...state, ...localState };

    case ActionTypes.SET_SELECTED_INPUT:
      return { ...state, ...action.payload };
    case ActionTypes.REFRESH_UNALLOCATED:
      return {
        ...initialState,
        displayObj: state.displayObj,
      };
    case ActionTypes.REFRESH_UNALLOCATED_DETAIL:
      return {
        ...state,
        displayObj: initialState.displayObj,
      };

    case ActionTypes.IS_LOADING:
      return { ...state, isLoading: action.isLoading };
    case ActionTypes.SET_PAGINATION_INDEX_UNALLOCATED:
      return {
        ...state,
        displayObj: { ...state.displayObj, countValue: action.payload },
      };

    default:
      return state;
  }
};

export default reducer;
